import { configureStore } from '@reduxjs/toolkit'
import imageReducer from '../store/reducers/imageSlice'

export const store = configureStore({
  reducer: imageReducer
})
